import { ITermSession } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SelectedTimeSliceModel } from '../models/selected_time_slice_model';

export class TimeSliceServant {
  constructor(private ngSelectedTimeSliceModel: SelectedTimeSliceModel) {}

  datesFromSessions(sessions: ITermSession[]) {
    const sortedSessions = _4.sortBy(sessions, (session) => session.session_start_dt);
    const sessionEndDates: string[] = _4.sortBy(_4.compact(_4.map(sessions, 'session_end_dt')));
    const lastSessionEndDate = _4.last(sessionEndDates);
    const startDates: string[] = _4.compact(_4.map(sortedSessions, 'session_start_dt'));
    return startDates.concat([lastSessionEndDate]);
  }

  isDateSelected(startDate: moment.Moment) {
    const timeSliceStartDate = moment(startDate);
    const selectedTimeSlice = this.ngSelectedTimeSliceModel.read();

    let isActive = false;
    if (selectedTimeSlice.timeSliceStartDate && selectedTimeSlice.timeSliceEndDate) {
      const hasSameStartDate = timeSliceStartDate.isSame(selectedTimeSlice.timeSliceStartDate);
      isActive = hasSameStartDate;
    }

    return isActive;
  }
  buildTimeSlices(startDate: moment.Moment, endDate: moment.Moment) {
    const builtTimeSlicesToReturn: any[] = [];
    const currentWeekStartDate = startDate.startOf('week'); // Sunday

    let timeSliceStartDate;
    let timeSliceEndDate;
    let isActive;

    while (currentWeekStartDate.isSameOrBefore(endDate)) {
      timeSliceStartDate = moment(currentWeekStartDate);
      timeSliceEndDate = moment(currentWeekStartDate).day(6);

      isActive = this.isDateSelected(startDate);

      builtTimeSlicesToReturn.push({
        timeSliceStartDate,
        timeSliceEndDate,
        startDisplay: timeSliceStartDate.format('MMM DD, YYYY'),
        endDisplay: timeSliceEndDate.format('MMM DD, YYYY'),
        startUnix: timeSliceStartDate.startOf('day').unix(),
        endUnix: timeSliceEndDate.endOf('day').unix(),
        startDayLabel: timeSliceStartDate.format('D'),
        isActive
      });
      currentWeekStartDate.day(7);
    }
    return builtTimeSlicesToReturn;
  }
}

angular.module('capability-ng-scheduler').service('ngTimeSliceServant', TimeSliceServant);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/time_slice_tiles/servants/time_slice_servant.ts